import { ApiResult } from 'interfaces/APITypes';
import { GameResourceSettings } from 'interfaces/StudioTypes';

import { contentInstance, makeRequest } from './client';

export interface UpdateGamePayload {
  public?: boolean;
  settings?: Partial<GameResourceSettings>;
  defaultSets?: string[];
}

export const getGames = async (): Promise<ApiResult> => {
  return makeRequest(contentInstance.get('/games'));
};

export const getGame = async (gameId: string, params?: { withDefaultSets?: 1 | 0 }): Promise<ApiResult> => {
  return makeRequest(contentInstance.get(`/games/${gameId}`, { params }));
};

export const updateGame = async (code: string, payload: UpdateGamePayload): Promise<ApiResult> => {
  return makeRequest(contentInstance.patch(`/games/${code}`, payload));
};
